module.exports = __webpack_public_path__ + "static/media/signup-background.26f3bba6.png";